import "slick-carousel";
import '~/js/modules/stickyNav';
import '~/js/views/general/about/includes/scroll-below';
import '~/js/views/resorts/includes/slider-highlights.js';
// const playTopVideoBtn = document.querySelector('.play-button');
// const playCollageVideoBtn = document.querySelector('.play-button')
const $sliderExchange1 = $(".js-slick-slider-exchange-1");


$sliderExchange1.slick({
  centerPadding: "20%",
  cssEase: "ease-out",
  lazyLoad: "progressive",
  pauseOnFocus: false,
  pauseOnHover: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  adaptiveHeight: true,
  infinite: true,
  arrows: true,
  centerMode: false,
  speed: 500,
  dots: false,
  prevArrow: $(".js-prev-slide-in-slider-exchange-1"),
  nextArrow: $(".js-next-slide-in-slider-exchange-1"),
  responsive: [
    {
      breakpoint: 768,
      settings: {
        lazyLoad: "ondemand",
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

if (
  !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Edge|MSIE \d|Trident.*rv:/i.test(
    navigator.userAgent
  ) &&
  window.innerWidth > 768
) {
  let currentTime = 0;
  const headerVideo = document.querySelector(".top-banner video");
  const heroImage = document.querySelector(".hero-image");

  const videoCheck = setInterval(() => {
    currentTime = headerVideo.currentTime;
    if (currentTime > 0.1) {
      heroImage.classList.add("hiding");
      headerVideo.classList.add("playing");
      clearInterval(videoCheck);
    }
  }, 500);
}

$(document).ready(function(){
    var coll = document.getElementsByClassName("collapsible");
    var i;

    for (i = 0; i < coll.length; i++) {
        coll[i].addEventListener("click", function() {
            this.classList.toggle("active");
            var content = this.nextElementSibling;
            if (content.style.maxHeight){
            content.style.maxHeight = null;
            } else {
            content.style.maxHeight = content.scrollHeight + "px";
            } 
        });
    }
});

const $autoplay = window.location.search.includes("autoplay");
const $videoToggle = $(".top-video");

if ($autoplay) {
  $videoToggle.click();
}

